// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_33zQl","headItem":"index_headItem_dETRO","headIcon":"index_headIcon_1j2yO","table":"index_table_c3tpM","avatar":"index_avatar_3Qc5R"};